<template>
    <div>
        <v-dialog
            v-model="$store.state.dialog"
            width="50%"
            :fullscreen="isfullscreen"
            persistent
            transition="dialog-bottom-transition"
        >
            <v-card flat class="px-4 pt-4">
                <!-- dialog toolbar -->
                <v-toolbar height="50" flat>
                    <h5>
                        {{
                            $store.state.itemDetails.dialogType == "add"
                                ? "إضافة"
                                : "تعديل"
                        }}
                        {{ this.$route.meta.single }}
                    </h5>
                    <v-spacer />
                    <!-- <v-btn small icon fab color="" @click="isfullscreen = !isfullscreen">
                        <v-icon small>{{ isfullscreen ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon>
                    </v-btn> -->
                    <v-btn
                        :disabled="$global.state.loading"
                        @click="close()"
                        fab
                        small
                        icon
                        color="grey"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider class="mx-4" />

                <!-- form body -->
                <v-form
                    @submit.prevent="submit()"
                    ref="form"
                    lazy-validation
                    v-model="valid"
                >
                    <v-container>
                        <v-card flat class="py-4 px-1">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <h6 class="mb-1">
                                        الوصف
                                        <span class="required">*</span>
                                    </h6>
                                    <v-text-field
                                        v-model="caption"
                                        :rules="[$global.state.required()]"
                                        required
                                        outlined
                                        hide-details="auto"
                                        filled
                                        dense
                                        placeholder="الوصف"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <h6 class="mb-1">الصورة</h6>
                                    <v-file-input
                                        v-model="image"
                                        ref="imageProject"
                                        @change="InputImage(image)"
                                        :rules="[validateImageOrVideo]"
                                        :error-messages="errorMessage"
                                        accept="image/*"
                                        outlined
                                        hide-details="auto"
                                        filled
                                        dense
                                        placeholder="الصورة"
                                    ></v-file-input>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <h6 class="mb-1">رابط الفيديو</h6>
                                    <v-text-field
                                        v-model="videoUrl"
                                        @input="triggerValidation"
                                        :rules="[
                                            validateImageOrVideo,
                                            $validations.urlFormat(),
                                        ]"
                                        outlined
                                        hide-details="auto"
                                        filled
                                        dense
                                        placeholder="https://example.com/video.mp4 أو https://youtube.com/watch?v=..."
                                    ></v-text-field>
                                </v-col>
                                <!-- Image Preview -->
                                <v-col cols="12" md="6">
                                    <h6 class="mb-1">معاينة الصورة</h6>
                                    <v-card flat outlined min-height="200">
                                        <div v-if="link">
                                            <v-img
                                                max-height="300"
                                                contain
                                                :src="link"
                                                alt="صورة المعاينة"
                                            >
                                            </v-img>
                                        </div>
                                        <div
                                            v-else
                                            class="d-flex align-center justify-center"
                                            style="height: 200px"
                                        >
                                            <span class="grey--text"
                                                >لا توجد صورة</span
                                            >
                                        </div>
                                    </v-card>
                                </v-col>
                                <!-- Video Preview -->
                                <v-col cols="12" md="6">
                                    <h6 class="mb-1">معاينة الفيديو</h6>
                                    <v-card flat outlined min-height="200">
                                        <div
                                            v-if="
                                                videoUrl && isValidUrl(videoUrl)
                                            "
                                        >
                                            <!-- YouTube Video -->
                                            <div v-if="isYouTubeUrl(videoUrl)">
                                                <iframe
                                                    :src="
                                                        getYouTubeEmbedUrl(
                                                            videoUrl
                                                        )
                                                    "
                                                    width="100%"
                                                    height="300"
                                                    frameborder="0"
                                                    allowfullscreen
                                                ></iframe>
                                            </div>
                                            <!-- Regular Video -->
                                            <div v-else>
                                                <video
                                                    controls
                                                    style="
                                                        max-height: 300px;
                                                        width: 100%;
                                                    "
                                                >
                                                    <source
                                                        :src="videoUrl"
                                                        type="video/mp4"
                                                    />
                                                    <source
                                                        :src="videoUrl"
                                                        type="video/webm"
                                                    />
                                                    <source
                                                        :src="videoUrl"
                                                        type="video/ogg"
                                                    />
                                                    المتصفح لا يدعم تشغيل
                                                    الفيديو
                                                </video>
                                            </div>
                                        </div>
                                        <div
                                            v-else
                                            class="d-flex align-center justify-center"
                                            style="height: 200px"
                                        >
                                            <span class="grey--text"
                                                >لا يوجد فيديو</span
                                            >
                                        </div>
                                    </v-card>
                                </v-col>
                                <!-- attachments -->
                            </v-row>
                            <v-divider class="ml- mt-8" />

                            <!-- actions -->
                            <div class="mt-4">
                                <v-btn
                                    type="submit"
                                    :loading="loading"
                                    color="primary"
                                    class="btn"
                                    :disabled="!valid"
                                >
                                    أضافة
                                    <v-icon small right>fi fi-rr-disk</v-icon>
                                </v-btn>
                                <v-btn @click="close()" text class="mr-2 btn">
                                    إلغاء
                                </v-btn>
                            </div>
                        </v-card>
                    </v-container>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import validations from "@/utils/validations";

export default {
    data: () => ({
        isfullscreen: false,
        valid: true,
        validImage: true,
        errorMessage: "",
        image: null,
        link: null,
        loading: false,
        caption: null,
        videoUrl: null,
        $validations: validations,
    }),

    created() {
        this.reset();
    },

    mounted() {},

    methods: {
        InputImage(image) {
            // console.log(image && image.type && image.type.startsWith("image/"));
            if (image && image.type && image.type.startsWith("image/")) {
                // If the image parameter exists and has a type starting with 'image/'
                // Convert the image to base64 and log the link
                this.ConvertImageToBase64(image, (base64Link) => {
                    // console.log(base64Link);
                    this.link = base64Link;
                });
                this.errorMessage = null;
                this.valid = true;
            } else {
                // If the image parameter is not of type 'image', make it empty or null
                // console.log(image ? null : "");
                this.link = null;
                this.image = null;
                this.errorMessage = "File Must be type Of Image";
                this.valid = false;
                if (image) {
                    this.$refs.imageProject.reset();
                }
            }
            // Trigger validation after image change
            this.triggerValidation();
        },
        ConvertImageToBase64(image, callback) {
            const reader = new FileReader();

            reader.onloadend = function () {
                // Callback with the base64 link when the conversion is complete
                callback(reader.result);
            };

            reader.readAsDataURL(image);
        },
        validateImageOrVideo() {
            const hasImage = this.image && this.image instanceof File;
            const hasValidVideo =
                this.videoUrl &&
                this.videoUrl.trim() &&
                this.isValidUrl(this.videoUrl.trim());

            if (!hasImage && !hasValidVideo) {
                return "يجب رفع صورة أو إدخال رابط فيديو صالح";
            }
            return true;
        },
        triggerValidation() {
            // Trigger form validation
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.validate();
                }
            });
        },
        isValidUrl(url) {
            if (!url) return false;
            const urlRegex =
                /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/?#][^\s]*)?$/i;
            return urlRegex.test(url);
        },
        isYouTubeUrl(url) {
            if (!url) return false;
            const youtubeRegex =
                /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|m\.youtube\.com\/watch\?v=)/i;
            return youtubeRegex.test(url);
        },
        getYouTubeEmbedUrl(url) {
            if (!url) return "";
            let videoId = "";

            console.log("Processing YouTube URL:", url);

            try {
                if (
                    url.includes("youtube.com/watch?v=") ||
                    url.includes("m.youtube.com/watch?v=")
                ) {
                    const urlParams = new URL(url).searchParams;
                    videoId = urlParams.get("v");
                    console.log("Extracted video ID from watch URL:", videoId);
                } else if (url.includes("youtu.be/")) {
                    videoId = url
                        .split("youtu.be/")[1]
                        .split("?")[0]
                        .split("&")[0];
                    console.log(
                        "Extracted video ID from youtu.be URL:",
                        videoId
                    );
                } else if (url.includes("youtube.com/embed/")) {
                    console.log("URL is already embed format");
                    return url;
                }

                if (videoId) {
                    const embedUrl = `https://www.youtube.com/embed/${videoId}`;
                    console.log("Generated embed URL:", embedUrl);
                    return embedUrl;
                }
            } catch (error) {
                console.error("Error parsing YouTube URL:", error);
            }

            console.log("Returning original URL:", url);
            return url;
        },
        reset() {
            this.caption = "";
            this.link = null;
            this.videoUrl = null;
            this.loading = false;
            this.errorMessage = "";
            this.valid = true;
            this.validImage = true;
        },

        submit() {
            this.$refs.form.validate();
            if (this.$refs.form.validate()) {
                this.addItem();
            }
        },

        async addItem() {
            this.loading = true;
            let formData = new FormData();
            if (this.image) {
                formData.append("image", this.image);
            }
            formData.append("caption", this.caption);
            if (this.videoUrl) {
                formData.append("videoUrl", this.videoUrl);
            }
            await this.$http
                .post(`${this.$route.meta.endPoint}`, formData, {
                    "Content-Type": "multipart/form-data",
                })
                .then((res) => {
                    this.$emit(`refresh`);
                    this.close();
                    this.$store.dispatch("toastification/setToast", {
                        message: `${res.data.message}`,
                        type: "success",
                    });
                })
                .catch((err) => {
                    this.$store.dispatch("toastification/setToast", {
                        message: `${err.response.data.message}`,
                        type: "error",
                    });
                })
                .finally(() => (this.loading = false));
        },
        close() {
            this.reset();
            this.$refs.form.reset();
            this.resetValidation();
            this.$store.commit("setDialog");
            this.$store.commit("setItemDetails", {});
        },

        resetValidation() {
            this.$refs.form.resetValidation();
        },
    },
};
</script>
